import { AttachmentMediaUpload } from "features/attachments/attachment.types"

function isImage(attachment: AttachmentMediaUpload) {
  return (
    attachment.attachmentType == "Image" ||
    attachment.mimeContentType?.startsWith("image/") ||
    attachment.file?.type?.startsWith("image/")
  )
}

export class AttachmentFunctions {
  static isImage = isImage
}
